module.exports = __webpack_public_path__ + "img/img47.197f518e.svg";